import { useMutation } from '@tanstack/react-query';
import { Button, Form, Typography } from 'antd';
import { Input, message } from 'antd';
import { FC } from 'react';
import { authLogin } from '../../network/auth';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../services/store/slices/user';
import { Link, useNavigate } from 'react-router-dom';
import { parsePhoneNumber } from 'react-phone-number-input';
import { useIntl } from 'react-intl';

interface LoginFormProps {}
// const mobileRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
const emailRegex =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const LoginForm: FC<LoginFormProps> = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mutate, data, isLoading, isError, isSuccess } =
    useMutation(authLogin);
  const onFinish = (values: { email: string; password: string }) => {
    const data: {
      password: string;
      email?: string;
      phone?: string;
      phone_country_code?: string;
    } = {
      password: values?.password,
    };
    const isEmail: boolean = emailRegex?.test(values?.email);
    if (isEmail) {
      data['email'] = values?.email;
    } else {
      const phone = values?.email?.includes('+')
        ? values?.email
        : '+' + values?.email;
      const phoneNumber = parsePhoneNumber(phone || '');
      if (phoneNumber) {
        data['phone'] = phoneNumber?.nationalNumber;
        data['phone_country_code'] = phoneNumber?.country;
      } else {
        data['email'] = values?.email;
      }
    }

    mutate(data, {
      onSuccess: (res: any) => {
        console.log(res);
        if (
          res?.code !== 'ERR_BAD_REQUEST' &&
          res?.code !== 'ERR_BAD_RESPONSE'
        ) {
          const userData = res?.data?.data;
          if (userData?.token) {
            const isAdmin = userData?.user?.roles?.some(
              (s: any) => s?.name === 'admin'
            );
            const isSalonOwner = userData?.user?.roles?.some(
              (s: any) => s?.name === 'salon_owner'
            );
            const isTeamMember = userData?.user?.roles?.some(
              (s: any) => s?.name === 'team_member'
            );
            localStorage.setItem('token', userData?.token);
            dispatch(setUserData(userData));
            if (isSalonOwner) {
              if (userData?.user?.salon) {
                // message.success(intl.formatMessage({ id: "loginSuccess" }));
                navigate('/');
              } else {
                message.success(
                  intl.formatMessage({ id: 'mustCompleteSalonInfo' })
                );
                navigate('/onBoarding');
              }
            } else if (isAdmin) {
              navigate('/');
            } else if (isTeamMember) {
              navigate('/');
            }
          }
        } else {
          message.error(intl.formatMessage({ id: 'emailOrPasswordIsWrong' }));
        }
      },
      onError: () => {
        message.error(intl.formatMessage({ id: 'emailOrPasswordIsWrong' }));
      },
    });
    // const userDetailsMutate=useMutation(authLogin);
  };
  return (
    <div dir="rtl">
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          required={false}
          colon={false}
          label={intl.formatMessage({ id: 'email/phone' })}
          hasFeedback
          name={'email'}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'enterEmailOrPhone' }),
            },
            {
              validator(_, value) {
                const phone = value?.includes('+') ? value : '+' + value;
                const phoneNumber = parsePhoneNumber(phone || '');

                if (value && !emailRegex.test(value) && !phoneNumber) {
                  return Promise.reject(
                    new Error(intl.formatMessage({ id: 'invalidEmailOrPhone' }))
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            placeholder={intl.formatMessage({ id: 'enterEmailOrPhone' })}
          />
        </Form.Item>
        <Form.Item
          required={false}
          colon={false}
          label={intl.formatMessage({ id: 'password' })}
          hasFeedback
          name={'password'}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'enterPassword' }),
            },
          ]}
        >
          <Input.Password
            placeholder={intl.formatMessage({ id: 'password' })}
          />
        </Form.Item>
        <div className="text-end text-txt-link text-sm font-semibold mt-2 mb-4">
          <Link to="/forgot-password">
            {intl.formatMessage({ id: 'forgotPassword' })}
          </Link>
        </div>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="w-full"
            loading={isLoading}
          >
            {intl.formatMessage({ id: 'login' })}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginForm;
